import {
  createSlice,
  PayloadAction
} from "@reduxjs/toolkit"
import { AxiosError } from "axios";

import { SavedSurvey } from "#types/api";

interface SavedSurveyWithReadonly extends SavedSurvey {
  updated_at: string;
}

interface SavedSurveyState {
  isLoading: boolean;
  error: AxiosError | null;
  data: SavedSurveyWithReadonly[] | null;

  detail: SavedSurvey | null;
}

const initialState: SavedSurveyState = {
  isLoading: false,
  error: null,
  data: null,

  detail: null,
};

const savedSurveySlice = createSlice({
  name: "saved_surveys",
  initialState,
  reducers: {
    resetSavedSurvyes: () => initialState,
    getSavedSurveys: (state) => ({
      ...state,
      data: null,
      error: null,
      isLoading: true,
    }),
    setSavedSurveys: (state, action: PayloadAction<SavedSurveyWithReadonly[]>) => ({
      ...state,
      data: action.payload,
      error: null,
      isLoading: false,
    }),
    setSavedSurveysError: (state, action: PayloadAction<AxiosError>) => ({
      ...state,
      data: null,
      error: action.payload,
      isLoading: false,
    }),

    setSavedSurveyDetail: (state, action: PayloadAction<SavedSurvey>) => ({
      ...state,
      detail: action.payload,
      error: null,
      isLoading: false,
    }),
    clearSavedSurveyDetail: (state) => ({
      ...state,
      detail: null,
      error: null,
      isLoading: false,
    }),
  },
});

export default savedSurveySlice.reducer;

export const savedSurveysActions = savedSurveySlice.actions;
